export default __webpack_public_path__ + "static/media/degree-progress-mobile.a1189d8c.svg";